import { apiCallWrapper } from 'traveldesk-ui'

import OfferValidPeriod from '../models/OfferValidPeriod'
export default class ValidPeriodsApiService {
    static save = async (dispatch: any, model: OfferValidPeriod) => {
        return await apiCallWrapper<OfferValidPeriod>('/api/validperiods', 'POST', dispatch, model)
    }
}
